module.exports = __webpack_public_path__ + "static/img/anli.aab053c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/anli.jpg
// module id = +f62
// module chunks = 1